/**
 * 腾讯域：目标费率配置 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.tencent.dtos.feilv_target_config 对齐。
 *   - GET /api/v1/tencent/feilv-target-config  → 读配置当前态（任意登录用户可读，
 *     附链路近3/近7个工作日平均授信费率当前值 sxfl_per_3d / sxfl_per_7d 供回显）
 *   - PUT /api/v1/tencent/feilv-target-config  → 保存配置（仅 devinzhang /
 *     v_yazhou / admin，否则后端 403；模式/取值不合法后端 400；写库失败 500）
 */

import { request } from "../apiClient";

/** 目标费率取值模式（与后端 FEILV_MODE_* 常量对齐）。 */
export type FeilvMode = "custom" | "sxfl_3d" | "sxfl_7d";

/** 目标费率配置当前态（与后端 FeilvTargetConfigRecord 对齐；None 字段经 exclude_none 不下发）。 */
export interface FeilvTargetConfigRecord {
  config_key: string;
  feilv_mode: FeilvMode;
  /** custom 模式固定值（小数费率，如 0.0165=1.65%）；sxfl_* 模式下为切回 custom 的回显值。 */
  feilv_value: number;
  /** 链路近3个工作日平均授信费率当前值（无数据时不下发）。 */
  sxfl_per_3d?: number;
  /** 链路近7个工作日平均授信费率当前值（无数据/treaty_7d<=0 时不下发）。 */
  sxfl_per_7d?: number;
  create_user?: string;
  modify_user?: string;
  created_time?: string;
  updated_time?: string;
}

export interface SaveFeilvTargetConfigBody {
  feilv_mode: FeilvMode;
  /** 始终携带 custom 固定值：勾选 sxfl_* 模式时传「切回 custom 后要用的回显值」。 */
  feilv_value: number;
}

/** 读取目标费率配置当前态；表无行时后端返回默认态 custom + 0.0165。 */
export async function getFeilvTargetConfig(): Promise<FeilvTargetConfigRecord | null> {
  return request<FeilvTargetConfigRecord | null>(
    "/api/v1/tencent/feilv-target-config",
  );
}

/** 保存目标费率配置；返回保存后当前态（含更新后的审计列）。非白名单用户后端返回 403。 */
export async function saveFeilvTargetConfig(
  body: SaveFeilvTargetConfigBody,
): Promise<FeilvTargetConfigRecord> {
  return request<FeilvTargetConfigRecord>("/api/v1/tencent/feilv-target-config", {
    method: "PUT",
    body,
  });
}
